/* tslint:disable */
/* eslint-disable */
/**
 * SR AAT specification
 * Description
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RoleGroups } from './RoleGroups';
import {
    RoleGroupsFromJSON,
    RoleGroupsFromJSONTyped,
    RoleGroupsToJSON,
} from './RoleGroups';
import type { Status } from './Status';
import {
    StatusFromJSON,
    StatusFromJSONTyped,
    StatusToJSON,
} from './Status';
import type { StatusCodes } from './StatusCodes';
import {
    StatusCodesFromJSON,
    StatusCodesFromJSONTyped,
    StatusCodesToJSON,
} from './StatusCodes';

/**
 * 
 * @export
 * @interface RoleGroupsResponse
 */
export interface RoleGroupsResponse extends Status {
    /**
     * 
     * @type {RoleGroups}
     * @memberof RoleGroupsResponse
     */
    roleGroups?: RoleGroups;
}

/**
 * Check if a given object implements the RoleGroupsResponse interface.
 */
export function instanceOfRoleGroupsResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RoleGroupsResponseFromJSON(json: any): RoleGroupsResponse {
    return RoleGroupsResponseFromJSONTyped(json, false);
}

export function RoleGroupsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleGroupsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...StatusFromJSONTyped(json, ignoreDiscriminator),
        'roleGroups': !exists(json, 'roleGroups') ? undefined : RoleGroupsFromJSON(json['roleGroups']),
    };
}

export function RoleGroupsResponseToJSON(value?: RoleGroupsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...StatusToJSON(value),
        'roleGroups': RoleGroupsToJSON(value.roleGroups),
    };
}

